export function RewardsRecognitionFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/rewards-recognitions-filled.svg'"></ng-include>`
    }
}